module.exports = __webpack_public_path__ + "static/media/icon_152.b9e1fbac.svg";